import { BaseDto } from "../common/baseDto";

export interface ProductPlanDto extends BaseDto {
	

	yearMonth: string;			// 연월
	compCd: string;				// 사업장코드
	compNm: string;				// 사업장명
	itemCd: string;				// 품목코드/ITEMCD.MSTITEM
	itemNm: string;				// 품명
	itemSpec: string;			// 규격
	itemUnit: string;			// 단위
	planQty: number;			// 계획수량
	orderQty: number;			// 지시수량
	resultQty: number;			// 생산수량
	approveFlg: string;			// 생산계획승인여부
	remark: string;				// 비고

	inserted: boolean;
	isModified: boolean;
}


export const defaultProductPlanDto: ProductPlanDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	yearMonth: "",
	compCd: "",
	compNm: "",
	itemCd: "",
	itemNm: "",
	itemSpec: "",
	itemUnit: "",
	planQty: 0,
	orderQty: 0,
	resultQty: 0,
	approveFlg: "N",
	remark: "",

	inserted: false,
	isModified: false,
}

